export default "/images/80e5568660ddc8c2036aa71540c50b5e.jpg";